import { createFileRoute } from "@tanstack/react-router";
import { IntegrationsPage } from "./-integrations/integrations.page";

export const Route = createFileRoute("/integrations/")({
  component: IntegrationsPage,
  validateSearch: (search: Record<string, unknown>) => search,
});
